"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMediaToPlaylistDto = void 0;
class AddMediaToPlaylistDto {
    mediaId;
    mediaCampaignId;
    duration;
    hours;
    objectFit;
}
exports.AddMediaToPlaylistDto = AddMediaToPlaylistDto;
